import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import type EmployeeModel from './employee.ts';
import type TasEligibilityModel from './tas-eligibility.ts';
import type TasGroupingModel from './tas-grouping.ts';
import type { TransitionLogSignature } from '../types/tuition-assistance.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class TasParticipantModel extends Model {
  @attr declare payrollId: string;
  @attr declare state: string;
  @attr declare serviceData: Record<string, unknown>;
  @attr declare employmentStartDate: string;
  @attr declare transitionLog: TransitionLogSignature[];
  @attr declare eligibilityStrategy: string;

  /*************************
   **  Relationships      **
   *************************/
  @hasMany('tas-eligibility', { async: false, inverse: 'tasParticipant' })
  declare tasEligibilities: TasEligibilityModel[];
  @hasMany('tas-grouping', {
    async: false,
    inverse: 'tasProgramTemplate',
    as: 'tas-program-template',
  })
  declare tasGroupings: TasGroupingModel[];

  @belongsTo('employee', { async: false, inverse: 'tasParticipant' })
  declare employee: EmployeeModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare supervisor: EmployeeModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare departmentHead: EmployeeModel;

  // When a participant is "held" (aka "frozen" in product speak),
  // they are effectively barred from submitting any applications/programs.
  get isHeld() {
    return this.state === 'TAS.ParticipantState.HELD';
  }

  get isActive() {
    return this.state === 'TAS.ParticipantState.ACTIVE';
  }

  [Type] = 'tas-participant' as const;
}
